// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#agencySelectModal {
    border: 2px solid black;
    width: 50%;
    height: 60%;
    max-height: 565px;
}

#agencySelectModal .table-body {
    cursor: pointer;
}

.agencySearch {
    display: flex;
    width: 100%;
    margin: 16px auto 32px auto;
    justify-content: space-evenly;
    align-items: center;
}

.agencySearch span {
    font-size: 14px;
}

.agencySearch input {
    width: 50%;
    min-width: 0;
    height: 23px;
    padding: 3px 4px;
    border: 1px solid #dcdcdc;
    margin: 0 6.4px;
}

.agencySearch button {
    padding: 6px 18px;
}

.agencySearch + div{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 390px;
}

.searchAgencyBtn:hover {
    background-color: #8f8f8f;
}

.agencyAllocController {
    display: flex;
    width: 60%;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    padding: 16px 0;
}

.agencyAllocController button {
    display: flex;
    justify-content: center;
    font-size: 13.6px;
    padding: 6.4px 0;
    width: 96px;
}

@media screen and (max-width: 600px) {
    #agencySelectModal{
        width: 90%;
    }
    .agencySearch {
        width: 90%;
    }
    .agencySearch input{
        width: 45%;
    }

    .agencySearch span {
        font-size: 12px;
    }

    .agencySearch button {
        font-size: 12px;
    }

    .agencyAllocController {
        width: 80%;
    }

    .agencyAllocController button {
        width: 40%;
        font-size: 12px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Modal_AgencySelect.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,UAAU;IACV,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,2BAA2B;IAC3B,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,UAAU;IACV,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;QACV,eAAe;IACnB;AACJ","sourcesContent":["#agencySelectModal {\n    border: 2px solid black;\n    width: 50%;\n    height: 60%;\n    max-height: 565px;\n}\n\n#agencySelectModal .table-body {\n    cursor: pointer;\n}\n\n.agencySearch {\n    display: flex;\n    width: 100%;\n    margin: 16px auto 32px auto;\n    justify-content: space-evenly;\n    align-items: center;\n}\n\n.agencySearch span {\n    font-size: 14px;\n}\n\n.agencySearch input {\n    width: 50%;\n    min-width: 0;\n    height: 23px;\n    padding: 3px 4px;\n    border: 1px solid #dcdcdc;\n    margin: 0 6.4px;\n}\n\n.agencySearch button {\n    padding: 6px 18px;\n}\n\n.agencySearch + div{\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    height: 390px;\n}\n\n.searchAgencyBtn:hover {\n    background-color: #8f8f8f;\n}\n\n.agencyAllocController {\n    display: flex;\n    width: 60%;\n    justify-content: space-between;\n    align-items: center;\n    margin: 0 auto;\n    padding: 16px 0;\n}\n\n.agencyAllocController button {\n    display: flex;\n    justify-content: center;\n    font-size: 13.6px;\n    padding: 6.4px 0;\n    width: 96px;\n}\n\n@media screen and (max-width: 600px) {\n    #agencySelectModal{\n        width: 90%;\n    }\n    .agencySearch {\n        width: 90%;\n    }\n    .agencySearch input{\n        width: 45%;\n    }\n\n    .agencySearch span {\n        font-size: 12px;\n    }\n\n    .agencySearch button {\n        font-size: 12px;\n    }\n\n    .agencyAllocController {\n        width: 80%;\n    }\n\n    .agencyAllocController button {\n        width: 40%;\n        font-size: 12px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
